export default "__VITE_ASSET__BulmB5F7__"